export default {"src":"/fly/_next/static/media/promo-code-close.2f0315e3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};